"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineStyleSchema = void 0;
const zod_1 = require("zod");
exports.LineStyleSchema = zod_1.z.enum(['solid', 'dash', 'dot', 'dash-dot']);
//# sourceMappingURL=LineStyle.js.map